export default "__VITE_ASSET__CsLta7Ds__"